// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sensorListTableBodyRow__Empnv {
  font-size: 14px;
  color: var(--tables-primary-row-text-main);
  text-decoration: none;
  padding: 16px 25px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background-color: var(--tables-primary-row-surface-default);
  overflow: initial;
}
@media (max-width: 810px) {
  .sensorListTableBodyRow__Empnv {
    font-size: 12px;
    padding: 16px 15px;
  }
}
.sensorListTableBodyRow__Empnv:hover {
  cursor: pointer;
  background-color: var(--tables-primary-row-surface-hover);
}

.sensorListTableBodyName__JlnGS {
  width: 20%;
  min-width: 180px;
}
@media (max-width: 810px) {
  .sensorListTableBodyName__JlnGS {
    min-width: unset;
    max-width: 150px;
    width: 100%;
  }
}

.sensorListTableBodyCode__VPADr {
  width: 10%;
}
@media (max-width: 810px) {
  .sensorListTableBodyCode__VPADr {
    width: 30%;
  }
}

.sensorListTableBodyStatus__Pka7F {
  width: 50%;
}
@media (max-width: 1080px) {
  .sensorListTableBodyStatus__Pka7F {
    width: 48%;
  }
}
@media (max-width: 810px) {
  .sensorListTableBodyStatus__Pka7F {
    width: 50%;
  }
}

.sensorListTableBodyType__APDAM {
  width: 20%;
  min-width: 120px;
  display: flex;
  justify-content: space-between;
}

.sensorListTableBodyLinks__TAWJC {
  width: 20%;
  min-width: 120px;
  display: flex;
  flex-direction: column;
}

.sensorListTableBodyLinksItem__fV2Zp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 810px) {
  .sensorListTableBodyLinksItem__fV2Zp {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 5px;
  }
}

.sensorListTableBodyLink__pofJ9 {
  width: 10%;
}

.sensorListTableBodyBtn__Bknrr {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-surface) !important;
  text-decoration: none;
  text-transform: uppercase;
  background-color: transparent;
  border: none !important;
  cursor: pointer;
  z-index: 2;
}

.sensorListTableBodyEmpty__vg_pU {
  text-align: center;
  padding: 50px 0;
  background-color: var(--tables-primary-row-surface-default);
}

.unselected__UwjkS {
  pointer-events: none;
}

.sensorListTableBodyRowSkeleton__GWGFR {
  padding-top: 16px;
  padding-bottom: 16px;
}
.sensorListTableBodyRowSkeleton__GWGFR > div {
  height: 20px;
}

.skeletonText__tVAyx {
  width: calc(100% - 10px);
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsList/components/SensorListTableBody/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,0CAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yDAAA;EACA,2DAAA;EACA,iBAAA;AAzEF;AA2EE;EAXF;IAYI,eAAA;IACA,kBAAA;EAxEF;AACF;AA0EE;EACE,eAAA;EACA,yDAAA;AAxEJ;;AA4EA;EACE,UAAA;EACA,gBAAA;AAzEF;AA0EE;EAHF;IAII,gBAAA;IACA,gBAAA;IACA,WAAA;EAvEF;AACF;;AA0EA;EACE,UAAA;AAvEF;AAwEE;EAFF;IAGI,UAAA;EArEF;AACF;;AAwEA;EACE,UAAA;AArEF;AAsEE;EAFF;IAGI,UAAA;EAnEF;AACF;AAoEE;EALF;IAMI,UAAA;EAjEF;AACF;;AAoEA;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AAjEF;;AAoEA;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAjEF;;AAoEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAjEF;AAkEE;EAJF;IAKI,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,gBAAA;EA/DF;AACF;;AAkEA;EACE,UAAA;AA/DF;;AAkEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AA/DF;;AAkEA;EACE,kBAAA;EACA,eAAA;EACA,2DAAA;AA/DF;;AAkEA;EACE,oBAAA;AA/DF;;AAkEA;EACE,iBAAA;EACA,oBAAA;AA/DF;AAiEE;EACE,YAAA;AA/DJ;;AAmEA;EACE,wBAAA;EACA,YAAA;AAhEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sensorListTableBodyRow {\n  font-size: 14px;\n  color: var(--tables-primary-row-text-main);\n  text-decoration: none;\n  padding: 16px 25px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background-color: var(--tables-primary-row-surface-default);\n  overflow: initial;\n\n  @media (max-width: 810px) {\n    font-size: 12px;\n    padding: 16px 15px;\n  }\n\n  &:hover {\n    cursor: pointer;\n    background-color: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.sensorListTableBodyName {\n  width: 20%;\n  min-width: 180px;\n  @media (max-width: 810px) {\n    min-width: unset;\n    max-width: 150px;\n    width: 100%;\n  }\n}\n\n.sensorListTableBodyCode {\n  width: 10%;\n  @media (max-width: 810px) {\n    width: 30%;\n  }\n}\n\n.sensorListTableBodyStatus {\n  width: 50%;\n  @media (max-width: 1080px) {\n    width: 48%;\n  }\n  @media (max-width: 810px) {\n    width: 50%;\n  }\n}\n\n.sensorListTableBodyType {\n  width: 20%;\n  min-width: 120px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.sensorListTableBodyLinks {\n  width: 20%;\n  min-width: 120px;\n  display: flex;\n  flex-direction: column;\n}\n\n.sensorListTableBodyLinksItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media (max-width: 810px) {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding-top: 5px;\n  }\n}\n\n.sensorListTableBodyLink {\n  width: 10%;\n}\n\n.sensorListTableBodyBtn {\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-surface) !important;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none !important;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.sensorListTableBodyEmpty {\n  text-align: center;\n  padding: 50px 0;\n  background-color: var(--tables-primary-row-surface-default);\n}\n\n.unselected {\n  pointer-events: none;\n}\n\n.sensorListTableBodyRowSkeleton {\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  & > div {\n    height: 20px;\n  }\n}\n\n.skeletonText {\n  width: calc(100% - 10px);\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensorListTableBodyRow": `sensorListTableBodyRow__Empnv`,
	"sensorListTableBodyName": `sensorListTableBodyName__JlnGS`,
	"sensorListTableBodyCode": `sensorListTableBodyCode__VPADr`,
	"sensorListTableBodyStatus": `sensorListTableBodyStatus__Pka7F`,
	"sensorListTableBodyType": `sensorListTableBodyType__APDAM`,
	"sensorListTableBodyLinks": `sensorListTableBodyLinks__TAWJC`,
	"sensorListTableBodyLinksItem": `sensorListTableBodyLinksItem__fV2Zp`,
	"sensorListTableBodyLink": `sensorListTableBodyLink__pofJ9`,
	"sensorListTableBodyBtn": `sensorListTableBodyBtn__Bknrr`,
	"sensorListTableBodyEmpty": `sensorListTableBodyEmpty__vg_pU`,
	"unselected": `unselected__UwjkS`,
	"sensorListTableBodyRowSkeleton": `sensorListTableBodyRowSkeleton__GWGFR`,
	"skeletonText": `skeletonText__tVAyx`
};
module.exports = ___CSS_LOADER_EXPORT___;
